import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
const items = [{
  title: 'Perfil Trino Express (PDF)',
  desc: 'El sistema paso a paso para identificar tus 3 pilares.'
}, {
  title: 'Checklist de Interpretación Rápida',
  desc: 'No más dudas, identifica tu "Gas Moment" en segundos.'
}, {
  title: 'Guía de Combinaciones Trinas',
  desc: 'Cómo unir tu número, tu sello y tu signo sin morir en el intento.'
}, {
  title: 'Hoja de Ruta de Integración',
  desc: 'Acciones concretas para alinear tu carrera y tus relaciones.'
}];
export function WhatYouGet() {
  return <section className="py-24 bg-trino-cream relative" data-id="element-156">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-157">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-159">
            <h2 className="text-3xl sm:text-4xl font-bold font-serif text-trino-burgundy mb-8" data-id="element-160">
              ¿Qué obtienes hoy?
            </h2>

            <div className="space-y-6" data-id="element-161">
              {items.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.15,
              duration: 0.5
            }} className="flex items-start space-x-4" data-id="element-162">
                  <CheckCircle2 className="w-6 h-6 text-trino-gold flex-shrink-0 mt-1" data-id="element-163" />
                  <div data-id="element-164">
                    <h4 className="text-lg font-bold text-trino-dark" data-id="element-165">
                      {item.title}
                    </h4>
                    <p className="text-trino-dark/70" data-id="element-166">{item.desc}</p>
                  </div>
                </motion.div>)}

              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.8,
              duration: 0.5
            }} className="mt-8 bg-gradient-to-r from-trino-burgundy to-trino-rose p-6 rounded-xl text-white shadow-lg flex items-start space-x-4" data-id="element-167">
                <Gift className="w-8 h-8 text-trino-gold flex-shrink-0" data-id="element-168" />
                <div data-id="element-169">
                  <h4 className="text-lg font-bold text-trino-gold mb-1" data-id="element-170">
                    BONUS: Plantilla Diario Trino
                  </h4>
                  <p className="text-white/90 text-sm" data-id="element-171">
                    Para registrar cómo tu energía se manifiesta día a día.
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-172">
            <div className="absolute inset-0 bg-trino-gold/20 rounded-full blur-3xl transform scale-90" data-id="element-173"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pW31TzCdY9VJbsEL41QE6o/perfil-trino6.png" alt="Bundle Perfil Trino" className="relative z-10 w-full max-w-md mx-auto rounded-2xl shadow-2xl transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-174" />
          </motion.div>
        </div>
      </div>
    </section>;
}